(() => {
  const ZOOM_LEVEL = 3;

  const clamp = (value, min, max) => {
    return Math.min(Math.max(value, min), max);
  };

  const initializeProductMagnifiers = () => {
    document.querySelectorAll('[data-mc-product-media]').forEach((media) => {
      if (media.dataset.mcMagnifierReady === 'true') return;

      const magnifier = media.querySelector('[data-mc-magnifier]');
      const primaryImage = media.querySelector(
        '.mc-product-card__image--primary'
      );
      const mediaLink = media.closest('.mc-product-card__media-link');

      if (!magnifier || !primaryImage) return;

      media.dataset.mcMagnifierReady = 'true';

      let pointerActive = false;
      let pointerMoved = false;
      let startX = 0;
      let startY = 0;

      const hideMagnifier = () => {
        magnifier.classList.remove('is-active');
        media.classList.remove('is-magnifying');
        pointerActive = false;
      };

      const updateMagnifier = (clientX, clientY) => {
        const rect = media.getBoundingClientRect();

        if (!rect.width || !rect.height) return;

        const x = clamp(clientX - rect.left, 0, rect.width);
        const y = clamp(clientY - rect.top, 0, rect.height);

        const imageUrl = primaryImage.currentSrc || primaryImage.src;

        if (!imageUrl) return;

        const lensWidth = magnifier.offsetWidth || 145;
        const lensHeight = magnifier.offsetHeight || 145;

        magnifier.style.left = `${x}px`;
        magnifier.style.top = `${y}px`;
        magnifier.style.backgroundImage = `url("${imageUrl}")`;
        magnifier.style.backgroundSize =
          `${rect.width * ZOOM_LEVEL}px ${rect.height * ZOOM_LEVEL}px`;

        magnifier.style.backgroundPosition =
          `${-(x * ZOOM_LEVEL - lensWidth / 2)}px ` +
          `${-(y * ZOOM_LEVEL - lensHeight / 2)}px`;

        magnifier.classList.add('is-active');
        media.classList.add('is-magnifying');
      };

      /*
        Desktop aur Shopify mobile preview:
        cursor image par move karte hi lens show hoga.
      */
      media.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch' && !pointerActive) return;

        if (pointerActive) {
          const movedX = Math.abs(event.clientX - startX);
          const movedY = Math.abs(event.clientY - startY);

          if (movedX > 5 || movedY > 5) {
            pointerMoved = true;
          }
        }

        updateMagnifier(event.clientX, event.clientY);
      });

      /*
        Real mobile:
        bag ke area par touch karte hi wahi area zoom hoga.
      */
      media.addEventListener('pointerdown', (event) => {
        pointerActive = true;
        pointerMoved = false;
        startX = event.clientX;
        startY = event.clientY;

        if (media.setPointerCapture) {
          media.setPointerCapture(event.pointerId);
        }

        updateMagnifier(event.clientX, event.clientY);
      });

      media.addEventListener('pointerup', (event) => {
        if (media.hasPointerCapture?.(event.pointerId)) {
          media.releasePointerCapture(event.pointerId);
        }

        window.setTimeout(hideMagnifier, 120);
      });

      media.addEventListener('pointercancel', hideMagnifier);
      media.addEventListener('pointerleave', () => {
        if (!pointerActive) {
          hideMagnifier();
        }
      });

      /*
        Zoom ke waqt finger move ki ho to product link open nahi hoga.
        Normal single tap se product page khul jayega.
      */
      mediaLink?.addEventListener('click', (event) => {
        if (pointerMoved) {
          event.preventDefault();
          pointerMoved = false;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeProductMagnifiers,
      { once: true }
    );
  } else {
    initializeProductMagnifiers();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeProductMagnifiers
  );
})();